import Vue from "vue";

Vue.filter("toLowerCase", function (value) {
  if (value === null || value === "-" || value === "") {
    return "-";
  } else {
    return value.toString().toLowerCase();
  }
});
